import {Component, OnInit} from "@angular/core";
import {AccountingService} from "./accounting.service";
import {ImportCARDAccountsDialogComponent} from "./import-card-accounts-dialog.component";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {RouteMapping} from "../misc/route-helper";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {handleErrors} from "../misc/handle-errors.decorator";
import {AccountSummaryGqlModel, AmountType, ExpenseGqlModel} from "./accounting.gql-model";
import {FilteredList} from "../helpers/filtered-list";
import {toggleLoading} from "../misc/loading.decorator";
import {ProjectService} from "../project/project.service";
import { AppSettingsService } from "../app-settings/app-settings.service";
import { HasuraGraphqlService } from "../graphql/hasura-graphql-service";

@Component({
  templateUrl: "./card-expenses.template.pug",
  providers: [
    AccountingService,
    DialogService,
    HasuraGraphqlService,
  ],
})

export class CardExpensesComponent implements OnInit {
  projectId: string;
  projectName: string = "";
  projectStartDate = "";

  details = {};
  detailVisible = {};

  expenses: FilteredList<ExpenseGqlModel> = new FilteredList<ExpenseGqlModel>({
    searchKeys: ["month", "period", "attribute"],
    formKeys: ["month", "usdAmount", "localAmount", "attribute"],
  });

  summary: AccountSummaryGqlModel = new AccountSummaryGqlModel({});

  amountType: AmountType = "usdAmount";
  currency: string = "USD";
  projectCurrency: string = "USD";

  error: Error;

  editing: boolean = false;
  loading: boolean = false;

  paramsMap: RouteMapping[] = [
    {fieldName: "projectId", paramName: "projectId"} as RouteMapping,
  ];

  constructor(
    private accountingService: AccountingService,
    public dialogService: DialogService,
    public route: ActivatedRoute,
    public router: Router,
    private projectService: ProjectService,
    private appSettingsService: AppSettingsService,
    private hasuraGqlService: HasuraGraphqlService,
  ) {}

  setAmountType(amountType: AmountType) {
    this.amountType = amountType;
    if (this.amountType === "usdAmount") {
      this.currency = "USD";
    } else {
      this.currency = this.projectCurrency;
    }
  }

  @handleErrors()
  ngOnInit() {
    this.route.queryParams.forEach((value: Params) => {
      this.projectId = value.projectId;
    });
    this.loadSummary();
  }

  @toggleLoading()
  @handleErrors()
  async loadSummary() {

      let params: any = `id
      startDate: start_date`;
      const projectData = await this.hasuraGqlService.getProjectResponseFromHasura(this.projectId, params);
    this.projectStartDate = projectData.startDate;
    this.summary = await this.accountingService.loadSummary(this.projectId, this.projectStartDate);
    this.projectCurrency = "USD";
    this.projectName = this.summary.projectName;
    // Budget and expenses (CARD) have incorrect local amount data. Only usdAmount should be used. MSTT-1470
    this.setAmountType("usdAmount");

    this.summary.buckets.forEach((bucket) => {
      this.details[bucket.bucket] = new FilteredList<ExpenseGqlModel>({
        searchKeys: ["month", "period", "attribute"],
        formKeys: ["month", "usdAmount", "localAmount", "attribute"],
      });
      this.detailVisible[bucket.bucket] = false;
    });
  }

  @handleErrors()
  async showExpenseDetail(bucket?: string) {
    if (this.detailVisible[bucket]) {
      this.detailVisible[bucket] = false;
      return;
    }

    this.details[bucket].items = await this.accountingService.getExpenses(
      this.projectId,
      this.projectStartDate,
      bucket,
    );
    this.detailVisible[bucket] = true;
  }

  @toggleLoading()
  @handleErrors()
  async importExpenses() {
    await this.accountingService.getExpensesAccount({projectId: this.projectId});

    await this.loadSummary();
  }

  @handleErrors()
  async chooseCARDAccount(): Promise<any> {
    await ImportCARDAccountsDialogComponent.show(this.dialogService, this.projectId);

    await this.importExpenses();
  }
}
